import { atom } from 'recoil';

export const loadingState = atom({
    key: 'loadingState',
    default: false,
});

export const previousPage = atom({
    key: 'previousPage',
    default: '',
});

export const modalState = atom({
    key: 'modalState',
    default: {
        isOpen: false,
        message: '',
        success: false,
    },
});

export const interactiveModalState = atom({
    key: 'interactiveModalState',
    default: {
        isOpen: false,
        title: '',
        state: {},
        inputFields: '',
        actionArray: '',
    },
});

export const projectMenuState = atom({
    key: 'projectMenuState',
    default: 'Dashboard',
});

export const projectContentLoader = atom({
    key: 'projectContentLoader',
    default: 'false',
});
